import axios, { AxiosRequestConfig } from 'axios';
import store from '@/store/index';
import { EventBus } from '@/utils/EventBus';
import i18n from '@/locale';

export default class WebApi {
    urlPrefix: string = process.env.VUE_APP_API_URL as string;
    proSsoPrefix: string = process.env.VUE_APP_SSO_PRO_PREFIX as string;

    constructor() {
        axios.defaults.headers.get['X-Requested-With'] = 'XMLHttpRequest';
        axios.defaults.headers.post['X-Requested-With'] = 'XMLHttpRequest';
        // @ts-ignore
        axios.interceptors.request.use((config: AxiosRequestConfig) => {
            if (
                config.url &&
                config.method &&
                ['post', 'delete', 'put', 'patch', 'get'].includes(config.method) &&
                (config.url.startsWith('/') || config.url.startsWith(this.urlPrefix)) &&
                config.headers
            ) {
                // @ts-ignore
                config.headers['Accept-Language'] = 'en-US,en;q=0.5; fr-CH, fr;q=0.9';
                // @ts-ignore
                config.headers['X-App-Origin'] = 'ProWeb';
                // @ts-ignore
                if (!config.headers['Content-Type']) {
                    // @ts-ignore
                    config.headers['Content-Type'] = `application/json`;
                }
                if (['delete', 'get'].includes(config.method) && !config.data) {
                    config.data = {};
                }
            }
            return config;
        });

        axios.interceptors.response.use(response => {
            return response;
        }, error => {
            if (error.response) {
                if (error.response.status === 401) {
                    if (window.location.pathname !== '/') {
                        store.commit('GlobalStore/mutationUnLoginUser');
                        window.location.href = '/';
                    }
                } else if (error.response.status === 403) {
                    if (error.response.config && error.response.config.url && error.response.config.url.includes(`user_dates`)) {
                        console.log(error.response);
                    } else {
                        EventBus.$emit(`sent-notification`, i18n.global.t('ERRORS.PERMISSION'));
                    }
                } else if (error.response.status === 422) {
                    EventBus.$emit(`sent-notification`, error.response.data.errors[0]);
                }
            }
            return Promise.reject(error);
        });
    }
}
